import { userUtils } from '@/helpers';
import React, { useCallback, useEffect } from 'react';

export default function useDebugState<T>(initialState: T, debug = false, name = 'State', color = 'cyan'): [T, React.Dispatch<React.SetStateAction<T>>] {
	const [state, _setState] = React.useState<T>(initialState);

	const setState = useCallback(
		(action: React.SetStateAction<T>) => {
			_setState((prevState) => {
				const next = typeof action === 'function' ? (action as (prevState: T) => T)(prevState) : action;
				if (debug) {
					console.log(`%c${name}:`, `color: ${color}; font-weight: bold;`, 'Previous:', prevState);
					console.log(`%c${name}:`, `color: ${color}; font-weight: bold;`, 'Next:', next);
				}
				return next;
			});
		},
		[debug, name, color],
	);

	useEffect(() => {
		if (userUtils.isSuperAdmin() && debug) {
			(window as any)[name] = setState;
		}
	}, [debug, name, setState]);

	return [state, setState];
}
